import { api } from "@/lib/axios";

interface invoiceCreationProps {
  invoiceNum: number;
  unit?: string;
  unitSize?: string;
  poBox?: string;
  customField?: string;
  totalPrice: number;
  taxes?: number;
  services: {
    serviceName?: string;
    price?: number;
    quantity?: number;
  }[];
  createdAt: Date;
  buildingId: string;
  companyId: string;
}

export async function createInvoice({
  invoiceNum,
  unit,
  unitSize,
  poBox,
  customField,
  totalPrice,
  taxes,
  services,
  createdAt,
  buildingId,
  companyId,
}: invoiceCreationProps) {
  return await api.post(`/invoices/${buildingId}/${companyId}`, {
    customField,
    totalPrice,
    taxes,
    poBox,
    createdAt,
    unitSize,
    services,
    unit,
    invoiceNum,
  });
}
